import React from "react";
import { App } from "../App";
import { MaterialImageCapturer } from "./MaterialImageCapturer";
import { CaptureTool, ICaptureToolToolProps } from "./Capture/CaptureTool";


export enum EToolType {
  None,
  MaterialImageCapturer,
  Capture
}

interface Props {
  app:App;
  activeTool:EToolType;
  toolProps:ICaptureToolToolProps|null
};

export class Tool extends React.Component<Props> {
  constructor(props:Props) {
    super(props);
  };

  render = () => {
    const getTool = (toolType:EToolType) => {
      switch (toolType) {
        case EToolType.None:
          return;
        case EToolType.MaterialImageCapturer:
          return(
            <MaterialImageCapturer
              app = {this.props.app}
            />
          )
        case EToolType.Capture:
          return(
            <CaptureTool
              toolProps = {this.props.toolProps as ICaptureToolToolProps}
            />
          )
      }
    };

    const activeTool = getTool(this.props.activeTool);

    return (
      <div className='Tool' style={{position: 'fixed', zIndex: 14}}>
        {activeTool}
      </div>
    )
  };
}